import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32')
];

export const server_loads = [2,4];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/account": [6,[2,3]],
		"/(app)/account/addresses": [7,[2,3]],
		"/(app)/account/ageverification/verify": [~8,[2,3]],
		"/(app)/account/login": [9,[2,3]],
		"/(app)/account/orders": [10,[2,3]],
		"/(app)/account/orders/reorder/[order]": [12,[2,3]],
		"/(app)/account/orders/[order]": [11,[2,3]],
		"/api/reviews/create": [32],
		"/(app)/cart": [~13,[2]],
		"/(app)/checkout": [14,[2,4]],
		"/(app)/checkout/ageverification": [~15,[2,4]],
		"/(app)/checkout/ageverification/verifier": [16,[2,4]],
		"/(app)/checkout/user": [17,[2,4]],
		"/(app)/collections": [18,[2]],
		"/(app)/collections/[collection]": [19,[2]],
		"/(app)/game": [~20,[2]],
		"/(app)/game/play": [~21,[2]],
		"/(app)/pages": [22,[2]],
		"/(app)/pages/contact": [24,[2]],
		"/(app)/pages/reviews": [25,[2]],
		"/(app)/pages/tracking": [~26,[2]],
		"/(app)/pages/vape-shop": [~27,[2]],
		"/(app)/pages/vape-shop/[location]": [~28,[2]],
		"/(app)/pages/[page]": [23,[2]],
		"/(app)/products": [29,[2]],
		"/(app)/products/[product]": [30,[2]],
		"/(app)/search": [31,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';